import React from "react";
import ModalWrapper from "../Modals/ModalWrapper";

import { useState } from "react";

import { PrimaryInvestmentType } from "types";

import { Link } from "react-router-dom";

const GridInvestmentModals: React.FC<{ investments: PrimaryInvestmentType[] }> = ({ investments }) => {
  const [isVisible, setVisible] = React.useState(false); // Control rendering of ModalWrapper
  const [isAnimating, setIsAnimating] = React.useState(false);
  const [selectedInvestment, setSelectedInvestment] = React.useState<PrimaryInvestmentType | null>(investments[0]);
  const [inputValues] = React.useState<{ [key: string]: number | string }>({}); // Allow empty string
  const [isLoading] = useState(false);

  const closeModal = () => {
    setIsAnimating(false); // Start closing animation
    setVisible(false);
    setTimeout(() => {
      setVisible(false); // Remove from DOM after animation completes
      setSelectedInvestment(investments[0]);
    }, 250); // Delay to ensure animation completes
  };

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {isLoading ? (
        <div>Loading investments...</div>
      ) : (
        investments.map((investment, index) => <Link key={`primary-${index}`} to={investment.uri}></Link>)
      )}
      {isVisible && selectedInvestment && (
        <ModalWrapper
          investment={selectedInvestment}
          isAnimating={isAnimating}
          inputValue={Number(inputValues[selectedInvestment.title || "0"]) || 0}
          action="buy"
          func={async () => {
            setVisible(false);
          }}
          onClose={closeModal}
        />
      )}
    </div>
  );
};

export default GridInvestmentModals;
